/**
 * 2D vector length — the hot-path replacement for `Math.hypot(dx, dz)`.
 *
 * `Math.hypot` is variadic and does overflow/underflow-safe scaling, which
 * makes it an order of magnitude slower than the naive form. Room geometry is
 * in metres and nowhere near the ranges that scaling protects, and
 * `Math.sqrt(dx * dx + dz * dz)` was already the idiom in a dozen other
 * modules here — this gives that idiom one name so the hot callers share it.
 *
 * Results can differ from `Math.hypot` by an ulp; nothing in this codebase
 * compares distances at that resolution.
 *
 * Deliberately takes the SAME two arguments in the same order as the
 * `Math.hypot` calls it replaced, so a call site is converted by renaming the
 * callee alone — no argument expression is ever rewritten.
 *
 * `MATH_SQRT` is hoisted and that is LOAD-BEARING, not tidiness. A `Math.sqrt`
 * read from inside this body is a GLOBAL lookup, which is not inline-cacheable
 * in a `vm` context — measured at 2e7 calls, the global form runs 1801 ms in a
 * vm against 145 ms hoisted, and against 345 ms for the plain `Math.hypot` it
 * was meant to beat. Writing `Math.sqrt` here makes this helper SLOWER than
 * the builtin it replaces.
 */
const MATH_SQRT = Math.sqrt;

function hypot2(dx, dz) {
  return MATH_SQRT(dx * dx + dz * dz);
}

module.exports = { hypot2 };
